"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEffectOptionsValidation = void 0;
const messages_1 = require("../../../messages");
const createSchemaValidator_1 = require("../../../validations/createSchemaValidator");
const reporters_1 = require("../../../reporters");
const animations_1 = require("../../animations");
const effectValidationSchema_1 = require("./effectValidationSchema");
const createInvalidOptionsTypeWarningReporter = ({ effectName, propertyName, compName, }) => {
    return (message, messageParams) => {
        reporters_1.reportWarning(messages_1.messageTemplates.warning_invalid_type_effect_options({
            propertyName,
            compName,
            effectName,
            wrongValue: `${messageParams === null || messageParams === void 0 ? void 0 : messageParams.value}`,
            infoLink: animations_1.effectInfoLink(propertyName),
        }));
    };
};
const createWrongOptionsWarningReporter = ({ effectName, propertyName, compName, }) => {
    return (message, messageParams) => {
        reporters_1.reportWarning(messages_1.messageTemplates.warning_invalid_effect_options({
            propertyName,
            compName,
            effectName,
            wrongProperty: 'value',
            wrongValue: `the key "${messageParams === null || messageParams === void 0 ? void 0 : messageParams.propertyName}" cannot be set to the value "${messageParams === null || messageParams === void 0 ? void 0 : messageParams.value}"`,
            infoLink: animations_1.effectInfoLink(propertyName),
        }));
    };
};
const createEffectOptionsValidation = ({ propertyName, compName, }) => {
    return (effectName, effectOptions) => {
        if (!effectName) {
            return false;
        }
        if (effectOptions === undefined) {
            return true;
        }
        /**
         * Here we want to reuse createSchemaValidator, but
         * current implementation of it does not meet our needs.
         * We need:
         * 1. report warning instead of error
         * 2. report custom message instead of built by schema validator
         * Here below we have a hack where we pass warning report on for error reporting.
         */
        const invalidOptionTypeReporter = createInvalidOptionsTypeWarningReporter({
            effectName,
            propertyName,
            compName,
        });
        const isEffectOptionsTypeValid = () => createSchemaValidator_1.createSchemaValidator({
            reportError: invalidOptionTypeReporter,
            reportWarning: () => ({}),
        }, compName)(effectOptions, { type: ['object'] }, propertyName);
        if (!isEffectOptionsTypeValid()) {
            return false;
        }
        /**
         * Here we want to reuse createSchemaValidator, but
         * current implementation of it does not meet our needs.
         * We need:
         * 1. report warning instead of error
         * 2. report custom message instead of built by schema validator
         * Here below we have a hack where we pass warning report on for error reporting.
         */
        const invalidEffectOptionsReporter = createWrongOptionsWarningReporter({
            effectName,
            propertyName,
            compName,
        });
        const isEffectOptionsValid = () => createSchemaValidator_1.createSchemaValidator({
            reportError: invalidEffectOptionsReporter,
            reportWarning: () => ({}),
        }, compName)(effectOptions, effectValidationSchema_1.effectsValidationSchema[effectName], propertyName);
        if (!isEffectOptionsValid()) {
            return false;
        }
        return true;
    };
};
exports.createEffectOptionsValidation = createEffectOptionsValidation;
//# sourceMappingURL=effectOptionsValidation.js.map